export const IMAGES = {
    home: {
        image1: 'https://res.cloudinary.com/dvuq9n454/image/upload/v1639252879/66fd3cad-3c8b-408d-b8e4-542842f5e3ad_izagx5.jpg',
        image4: 'https://res.cloudinary.com/dvuq9n454/image/upload/v1639252608/dab1ae55-79fc-4ac7-846b-d1ff0184b1d1_d8ar0d.jpg'
    }
}